module.exports = __webpack_public_path__ + "img/amd.1ee6736d.png";